import type { Seals } from "gql/api";
import type { Maybe } from "graphql/jsutils/Maybe";

export function computeSealLabel(
  seal?: Maybe<Partial<Seals>>,
  useHSShaft?: boolean | null | undefined
): string | null {
  if (seal) {
    return useHSShaft === true
      ? `${seal.manufacturer} / ${seal.outer_diameter_inches}  / ${seal.configuration} (HS Shaft)`
      : `${seal.manufacturer} / ${seal.outer_diameter_inches}  / ${seal.configuration} (STD Shaft)`;
  }
  return null;
}
